import API from 'config/api'
import { appRoutes } from 'config/routes'
import Button from 'deprecated/atoms/button'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled'
import axios from 'utils/axios'
import { loginUserSuccess } from '../../../actions/AuthActions'
import './login.css'

const EmailLogin = (props): JSX.Element => {
  const history = useHistory()
  function useQuery() {
    return new URLSearchParams(useLocation().search)
  }
  const query = useQuery()
  const token = query.get('token')

  const getSession = async () => {
    try {
      const res = await axios.post(API.sessions, {
        token
      })
      localStorage.setItem('token', res.data.data.access_token)
      const userRes = await axios.get(API.currentUser, {
        headers: {
          Authorization: `Bearer ${res.data.data.access_token}`
        }
      })
      const user = { ...userRes.data.data, token: res.data.data.access_token }
      props.loginUserSuccess(user)
    } catch (error) {
      console.log(error.message)
    }

    history.push(appRoutes.myDashboard)
  }

  return (
    <EmailSuccess>
      <div>
        <h1>You are all set!</h1>
      </div>
      <footer>
        <div className="loginFooterButtonContainer">
          <Button
            label="Show me my sponsorships"
            type="submit"
            onClick={getSession}
            className="primary buttonLogin"
            data-ref="loginFormSubmitButton"
          />
        </div>
      </footer>
    </EmailSuccess>
  )
}

const EmailSuccess = styled.div`
  h1 {
    margin-bottom: 2rem;
  }
  .primary.buttonLogin {
    width: 14.75rem;
  }

  label: emailSuccess;
`

const mapDispatchToProps = dispatch => ({
  loginUserSuccess: user => dispatch(loginUserSuccess(user))
})

export default withRouter(connect(null, mapDispatchToProps)(EmailLogin))
